import { useLottie } from "lottie-react";
import { useEffect } from "react";
import {
  AnimatedLogo,
  Container,
  LogoWrapper,
  Props,
  Splash,
} from "./LoadingSplash.Parts";

export const LoadingSplash = ({
  overlay,
  opaque,
  inline,
  onComplete,
  delayAnimation,
  loop = false,
}: Props) => {
  const { View: AnimatedLottie, play } = useLottie({
    loop,
    animationData: AnimatedLogo,
    autoplay: delayAnimation === undefined,
    onComplete: onComplete,
  });

  useEffect(() => {
    if (delayAnimation !== undefined) {
      const t = setTimeout(() => play(), delayAnimation);
      return () => clearTimeout(t);
    }
  }, [delayAnimation, play]);

  return (
    <Container $overlay={overlay} $opaque={opaque} $inline={inline}>
      <Splash $inline={inline}>
        <LogoWrapper $inline={inline}>{AnimatedLottie}</LogoWrapper>
      </Splash>
    </Container>
  );
};
